export enum UserInteractionStatus {
  STARTED = 'started',
  FINISHED = 'finished',
}
export type UserInteraction = {
  status: UserInteractionStatus | null;
};
